module.exports = __webpack_public_path__ + "img/check.6d988664.svg";